<p-card>
    <div class="flex justify-content-between align-items-center flex-wrap w-100 position-relative">
        <div class="flex align-items-center">
            <div>
                <p-button label="New" class="p-button-outlined" icon="pi pi-plus-circle" size="small"
                    (onClick)="CreateMenu()"></p-button>
            </div>
            <div class="flex align-items-center ml-3">
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" [(ngModel)]="searchKey" [placeholder]="placeholder" class=" p-inputtext-sm"
                        (keyup.enter)="searchMenu()" style="height: 35px; font-size: 0.875rem; padding-left: 2rem;" />
                </span>
                <p-button icon="pi pi-search" (onClick)="searchMenu()" [ngStyle]="{ height: '35px' }" [raised]="true" class="ml-2"
                    [size]="'small'" severity="info"></p-button>
            </div>
            <p-button *ngIf="selectedMenu && selectedMenu.length == 1" label="Edit" class="ml-2" icon="pi pi-pencil"
                (click)="editMenu()" size="small" severity="secondary"></p-button>
            <p-button *ngIf="selectedMenu && selectedMenu.length > 0" label="Delete" class="ml-2" icon="pi pi-trash"
                (click)="deleteMenu()" size="small" severity="danger"></p-button>
        </div>
        <h2 class="page-title-center">Menu List</h2>

        <div class="flex">
            <div class="flex align-items-center">
                <p-button icon="pi pi-refresh" size="small" (onClick)="refreshData()" [rounded]="true"
                    severity="info"></p-button>
            </div>
        </div>

    </div><br>



<div>

<!--Added search feild-->
<p-treeTable #dt1 [value]="files" [scrollable]="true" [tableStyle]="{'min-width':'50rem'}" scrollHeight="650px"
             styleClass="p-datatable-striped" [paginator]="true" [rows]="10"  (onPage)="loadMenu($event)"[(selection)]="selectedMenu"
             currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [rowsPerPageOptions]="[10,15, 20]"
             [globalFilterFields]="['menu','menuid', 'title', 'submenu']">
<ng-template pTemplate="header" >
    <tr>
        <th> Menu</th>
        <!-- <th>Menu</th> -->
        <th>Menu Id</th>
        <th>Sub Menu</th>
    </tr>
</ng-template>
<ng-template pTemplate="body" let-rowNode let-rowData="rowData">
    <tr [ttRow]="rowNode">
        <td>
            <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
            <p-treeTableCheckbox [value]="rowNode"></p-treeTableCheckbox>
            {{ rowData.menu }}
        </td>
        <td>{{ rowData.menuid }}</td>
        <td>{{ rowData.submenu }}</td>
    </tr>
</ng-template>
</p-treeTable>


</div>
</p-card>
